import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { validateRuleData, loading } from '@/decorators';
import vFooter from '@/views/components/common/vFooter.vue';
var User = namespace('user');
var Common = namespace('common');
var TabPage = namespace('tabpage');

var AuthorizePage = function (_super) {
  __extends(AuthorizePage, _super);

  function AuthorizePage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.validateCodeImageUrl = '';
    _this.validateCodeImageLoading = true;
    _this.loginLoading = false;
    _this.showCaptcha = false;
    _this.oauthLoading = false;
    _this.platformName = '';
    _this.step = _this.$enum.oauth.Step.WAIT_LOGIN;
    _this.accountId = '';
    _this.redirectUri = '';
    _this.code = '';
    _this.token = '';
    _this.formData = {
      account: '',
      password: '',
      image_validation_code: '',
      client_id: _this.$route.query.client_id
    };
    _this.formDataRule = {};
    return _this;
  }

  AuthorizePage.prototype.validateFormDataRule = function (validateData) {
    this.formDataRule = validateData;
  };

  AuthorizePage.prototype.isSubWindow = function () {
    return !!window.opener;
  };

  Object.defineProperty(AuthorizePage.prototype, "oauthUrl", {
    get: function get() {
      return this.redirectUri.indexOf('?') > -1 ? this.redirectUri + "&code=" + this.code : this.redirectUri + "?code=" + this.code;
    },
    enumerable: false,
    configurable: true
  });

  AuthorizePage.prototype.handleEnter = function () {
    this.handleLogin();
  };

  AuthorizePage.prototype.getNewValidateCodeImageUrl = function () {
    return this.$config.validateCodeImageUrl + "?t=" + new Date().getTime();
  };

  AuthorizePage.prototype.updatedValidateCodeImageUrl = function () {
    var _this = this;

    this.validateCodeImageLoading = true;
    this.validateCodeImageUrl = this.getNewValidateCodeImageUrl();
    var image = new Image();
    image.src = this.validateCodeImageUrl;

    image.onload = function () {
      _this.validateCodeImageLoading = false;
    };
  };

  AuthorizePage.prototype.queryOauthCode = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      var data, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4, this.$api.oauth.queryOauthCode(param, {
              Authorization: 'Bearer ' + this.token
            })];

          case 1:
            data = _a.sent().data;
            return [2, data];

          case 2:
            e_1 = _a.sent();
            this.step = this.$enum.oauth.Step.OAUTH_FAIL;
            return [2, Promise.reject(e_1)];

          case 3:
            return [2];
        }
      });
    });
  };

  AuthorizePage.prototype.queryClientInfo = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.oauth.queryClientInfo(param)];

          case 1:
            data = _a.sent().data;
            this.platformName = data.name;
            return [2];
        }
      });
    });
  };

  AuthorizePage.prototype.login = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res, e_2, res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2, 3, 4]);

            return [4, this.$api.oauth.login(params)];

          case 1:
            res = _a.sent();
            return [2, res];

          case 2:
            e_2 = _a.sent();
            res = e_2;

            if (res.data && res.data.show_captcha) {
              this.showCaptcha = true;
            }

            if (res instanceof Object && res.status === 403) {
              this.$router.push({
                name: '403',
                query: {
                  code: res.data.code
                }
              });
            }

            return [2, Promise.reject(res)];

          case 3:
            this.updatedValidateCodeImageUrl();
            return [7];

          case 4:
            return [2];
        }
      });
    });
  };

  AuthorizePage.prototype.handleSwitchImageValidateCode = function () {
    this.updatedValidateCodeImageUrl();
  };

  AuthorizePage.prototype.handleLogin = function () {
    var _this = this;

    var formDataRef = this.$refs.formDataRef;
    formDataRef.validate(function (valid) {
      return __awaiter(_this, void 0, void 0, function () {
        var params, res;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!valid) return [3, 3];
              params = this.$util.deepCopy(this.formData);
              params.password = this.$util.encryptionPassword(params.password);
              params.clean = true;
              return [4, this.login(params)];

            case 1:
              res = _a.sent();

              if (res.code !== 0) {
                return [2];
              }

              return [4, this.queryClientInfo({
                client_id: this.$route.query.client_id || ''
              })];

            case 2:
              _a.sent();

              this.step = this.$enum.oauth.Step.WAIT_OAUTH;

              if (res && res.data) {
                this.token = res.data.token;
              }

              _a.label = 3;

            case 3:
              return [2];
          }
        });
      });
    });
  };

  AuthorizePage.prototype.handleOauth = function () {
    return __awaiter(this, void 0, Promise, function () {
      var code;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.queryOauthCode({
              account_id: this.accountId,
              client_id: this.formData.client_id
            })];

          case 1:
            code = _a.sent().code;
            this.code = code;
            this.step = this.$enum.oauth.Step.OAUTH_SUCCESS;
            return [2];
        }
      });
    });
  };

  AuthorizePage.prototype.handleConfirm = function () {
    window.location.href = this.oauthUrl;
  };

  AuthorizePage.prototype.handleBack = function () {
    if (this.isSubWindow()) {
      window.close();
    } else {
      this.$router.push({
        name: 'IndexPage'
      });
    }
  };

  AuthorizePage.prototype.handleCancel = function () {
    if (this.isSubWindow()) {
      window.close();
    } else {
      this.step = this.$enum.oauth.Step.WAIT_LOGIN;
    }
  };

  AuthorizePage.prototype.created = function () {
    this.updatedValidateCodeImageUrl();
    var clientId = this.$route.query.client_id;
    var accountId = this.$route.query.client_account_id;
    var redirectUri = this.$route.query.redirect_uri;
    var lang = this.$route.query.lang;

    if (clientId) {
      this.formData.client_id = clientId;
    }

    if (accountId) {
      this.accountId = accountId;
    }

    if (redirectUri) {
      this.redirectUri = decodeURIComponent(redirectUri);
    }

    if (!clientId || !redirectUri || !this.$route.query.response_type) {
      this.$router.push({
        name: 'ResultPage',
        query: {
          state: 'error',
          content: encodeURI(this.t('链接不合法'))
        }
      });
      return;
    }

    if (lang) {
      this.$store.dispatch('language/setLanguage', lang);
    }
  };

  __decorate([validateRuleData('/api/v1/user_public/login')], AuthorizePage.prototype, "validateFormDataRule", null);

  __decorate([loading('oauthLoading')], AuthorizePage.prototype, "queryOauthCode", null);

  __decorate([loading('loginLoading')], AuthorizePage.prototype, "login", null);

  AuthorizePage = __decorate([Component({
    components: {
      vFooter: vFooter
    }
  })], AuthorizePage);
  return AuthorizePage;
}(Vue);

export default AuthorizePage;